import { createApp } from 'vue';
import { IonicVue } from '@ionic/vue';
import App from './ui/App.vue';
import GameManager from './lib/GameManager';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

// dark mode
import '@ionic/vue/css/palettes/dark.always.css';

/* Theme variables */
import './ui/theme/variables.css';

/* Display font — Cinzel (headers only; body uses Ionic system fonts) */
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&display=swap';
document.head.appendChild(fontLink);

document.addEventListener('DOMContentLoaded', async function() {
  const gameManager = new GameManager();
  await gameManager.init();

  const app = createApp(App);
  app.use(IonicVue);

  // Provide the game interface to all Vue components.
  // Components never touch GameManager or EventBus directly.
  app.provide('game', {
    state: gameManager.uiState,
    emit: gameManager.eventBus.emit.bind(gameManager.eventBus),
    dispatch: gameManager.eventBus.dispatch.bind(gameManager.eventBus),
  });

  app.mount('#app');
})
